// extracted by mini-css-extract-plugin
export default {"hualianBeer":"index_hualianBeer_4EwpU","header":"index_header_nLYu4","areaReports":"index_areaReports_XDLvp","navBar":"index_navBar_5hpyN","scene":"index_scene_iW9-F"};